import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, AlertTriangle, Rocket } from "lucide-react";

export default function AutomatedInsights({ productName }) {
  // In production, these would be generated from actual data analysis
  const insights = {
    working: [
      "UGC videos have 2.8x better engagement than static images",
      "Storytelling hooks (vs feature lists) = 65% lower CPM",
      "Videos with captions get 42% more 3s+ views",
      "Awareness campaigns with saves → 3.2x higher conversion later",
    ],
    toFix: [
      "Static image ads have 2.4x higher CPM - replace with video",
      "Ads without hooks lose 78% viewers in first 3s - add hooks",
      "3 campaigns spending >$100/day with engagement <2%",
    ],
    nextActions: [
      "Scale top UGC video to $150/day budget",
      "Pause all static image ads with engagement < 2%",
      "Create 3 new UGC videos with customer testimonials",
      "Add captions to all videos (increase accessibility)",
      "Test hook variations: question vs statistic vs story",
    ],
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* What's Working */}
      <Card className="border-green-200 dark:border-green-800">
        <CardHeader className="bg-green-50 dark:bg-green-950">
          <div className="flex items-center gap-2">
            <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />
            <CardTitle className="text-lg">✅ What's Working</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <ul className="space-y-3">
            {insights.working.map((insight, index) => (
              <li key={index} className="flex items-start gap-2 text-sm">
                <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
                <span className="text-foreground">{insight}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* What to Fix */}
      <Card className="border-orange-200 dark:border-orange-800">
        <CardHeader className="bg-orange-50 dark:bg-orange-950">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-orange-600 dark:text-orange-400" />
            <CardTitle className="text-lg">⚠️ What to Fix</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <ul className="space-y-3">
            {insights.toFix.map((insight, index) => (
              <li key={index} className="flex items-start gap-2 text-sm">
                <AlertTriangle className="h-4 w-4 text-orange-600 dark:text-orange-400 flex-shrink-0 mt-0.5" />
                <span className="text-foreground">{insight}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* Next Actions */}
      <Card className="border-primary">
        <CardHeader className="bg-primary/10">
          <div className="flex items-center gap-2">
            <Rocket className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">🚀 Next Actions</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <ul className="space-y-3">
            {insights.nextActions.map((action, index) => (
              <li key={index} className="flex items-start gap-2 text-sm">
                <span className="text-primary font-semibold flex-shrink-0">{index + 1}.</span>
                <span className="text-foreground">{action}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
